<section>
    <p-confirmDialog [baseZIndex]="10000" key="positionDialog" [position]="dialogPosition" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Admin</li>
            <li class="breadcrumb-item active">Country Search</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i> Country Search</span>
                        <button *ngIf="sharedService.checkPermission('Admin_Add')" style="height: 30px !important;width: auto!important;
                        margin-top: -2px;border-color: white;" pButton  type="button" icon="pi pi-plus" label="Add"
                            class="p-button-sm p-button-success float-right" (click)="addCountryDetails()"></button>
                        &nbsp;&nbsp;                        
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
<!--<section>
    <div class="row">
        <div class="col-md-1">

        </div>
        <div class="col-md-10">
            <div class="row">
                <div class="col-md-12" *ngIf="isCountryAdd || isCountryEdit">
                    <div class="card">
                        <div class="devcare-card-header">
                            <span class="devcare-card-title">{{title}}</span>
                        </div>
                        <div class="devcare-card-body">
                            <div class="row">
                                <div class="col-md-9">
                                    <form [formGroup] = "countryForm">
                                    <div class="p-fluid p-formgrid p-grid">
                                        <div class="p-field p-col-12 p-md-5">
                                            <label for="countryName">Country Name<span class="required-field">*</span></label>
                                            <input id="countryName" type="text" formControlName="countryName" pInputText>
                                        </div>
                                        <div class="p-field p-col-12 p-md-5">
                                            <label for="countryCode">Country Code</label>
                                            <input id="countryCode" type="text" formControlName="countryCode" pInputText>
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label for="isActive">Is Active</label>
                                            <br />
                                            <p-inputSwitch id="isActive" formControlName="isActive"></p-inputSwitch>
                                        </div>
                                    </div>
                                </form>
                                </div>
                                <div class="col-md-3 d-flex align-items-center">
                                    <button pButton pRipple type="button" label="{{buttonLabel}}" icon="pi pi-check"
                                class="p-button-sm p-button-raised p-button-success m-2" [disabled]="!this.countryForm.valid" (click)="save(countryForm)"></button>
                            <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
                                class="p-button-sm p-button-raised p-button-danger m-2" (click)="cancel()"></button>

                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="card">
                        <div class="devcare-table-card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <button pButton type="button" class="p-button-raised p-button-sm m-2" label="Add"
                                    icon="pi pi-plus" (click)="addCountryDetails()" *ngIf="(isCountryAdd === false) && (isCountryEdit === false)"></button>
                                </div>
                                <div class="col-md-6">
                                    <button class="p-button-sm" pButton type="button" icon="pi pi-search"
                                        (click)="search()" style="float: right;"></button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body devcare-table-card-body" style="overflow: hidden;">
                            <ngx-spinner [name]="countrySearchSpinner" [fullScreen]="false"  size="medium"></ngx-spinner>
                            <p-table #dt2 [value]="countryList" [lazy]="true"
                                (onLazyLoad)="loadCountryList($event)" dataKey="id" [rows]="10"
                                [showCurrentPageReport]="true" [resizableColumns]="true"
                                [rowsPerPageOptions]="[10,25,50]" [loading]="loading" styleClass="p-datatable-customers"
                                [paginator]="true" [totalRecords]="totalRecords"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [globalFilterFields]="['countryName','countryCode']">
                                <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                    </colgroup>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="countryName">Country Name </th>
                                        <th pSortableColumn="countryCode">Country Code</th>
                                        <th style="width: 8rem" pSortableColumn="isActive">Is Active</th>
                                        <th pSortableColumn="createdBy">Created By</th>
                                        <th pSortableColumn="createdOn">Created Date</th>
                                        <th >Actions</th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <p-columnFilter type="text" field="countryName"></p-columnFilter>
                                        </th>
                                        <th>
                                            <p-columnFilter type="text" field="countryCode"></p-columnFilter>
                                        </th>
                                        <th style="width: 8rem">
                                            <p-columnFilter type="boolean" field="isActive"></p-columnFilter>
                                        </th>
                                        <th>
                                            <p-columnFilter type="text" field="createdBy"></p-columnFilter>
                                        </th>
                                        <th>
                                            <p-columnFilter field="createdOn" type="date" [showOperator]="false"
                                                display="menu"> </p-columnFilter>
                                        </th>
                                        <th >
                                        
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-countryList>
                                    <tr>
                                        <td><span class="table-col-countryName">{{countryList.countryName}}</span></td>
                                        <td><span>{{countryList.countryCode}}</span></td>
                                        <td style="width: 8rem"><span class="customer-badge status-active" *ngIf="countryList.isActive">Active</span>
                                            <span class="customer-badge status-inactive" *ngIf="!countryList.isActive">Inactive</span>
                                        </td> 
                                        <td><span>{{countryList?.createdByUser?.firstName}}</span></td>
                                        <td><span>{{countryList.createdOn | date:'MM/dd/yyyy'}}</span></td>
                                        <td>
                                            <span>
                                                <a [routerLink]="" class="table-icon table-icon-edit" (click)="editCountryDetails(countryList.countryId)"><i class="fas fa-edit"></i></a>&nbsp;&nbsp;&nbsp;
                                                <a [routerLink]="" class="table-icon table-icon-view" (click)="showCountryDetails(countryList.countryId)"><i class="fas fa-eye"></i></a>&nbsp;&nbsp;&nbsp;
                                                <a [routerLink]="" class="table-icon table-icon-delete" (click)="deleteConfirm(countryList.countryId)"><i class="fas fa-trash-alt"></i></a>&nbsp;&nbsp;&nbsp;
                                                <p-menu class="[]" #menu popup="popup" [model]="items" appendTo="body"></p-menu>
                                                <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v" (click)="menu.toggle($event)"></i></a>&nbsp;&nbsp;
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="5">No Countries found.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-1">

        </div>
    </div>
    <p-toast></p-toast>
</section>-->
<section>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="devcare-card-body">
                  <div class="row">
                      <div class="col-md-4">
                          <button [ngClass] = "showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'" pButton type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
  
                          <button [ngClass] = "showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="fas fa-filter" (click)="bindShowFilter()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
                          
                          <button [ngClass] = "showToggle === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="pi pi-list" (click)="bindShowToggle()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
                      </div>
                      <div class="col-md-8">
  
                          <button pButton label="Export" class="p-button-raised  m-2" icon="pi pi-file-excel" type="button" style="float: right;height: 30px;" *ngIf="sharedService.checkPermission('Admin_Export')" (click)="exportCountryExcel()"
                           ></button>
                          
                           <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash" (click)="clearFilter(dt2)" 
                          style="float: right;height: 30px;"></button>
  
                          <!-- <button class="p-button-raised m-2" label ="Apply" pButton type="button" icon="pi pi-filter" (click)="applyFilter()"
                          [loading]="isSearchLoading" style="float: right;height: 30px;"></button> -->
                          
  
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12" *ngIf="isCountryAdd || isCountryEdit">
                    <div class="card">
                        <div class="devcare-card-header">
                            <span class="devcare-card-title">{{title}}</span>
                        </div>
                        <div class="devcare-card-body">
                            <div class="row">
                                <div class="col-md-9">
                                    <form [formGroup] = "countryForm">
                                    <div class="p-fluid p-formgrid p-grid">
                                        <div class="p-field p-col-12 p-md-5">
                                            <label for="countryName">Country Name<span class="required-field">*</span></label>
                                            <input id="countryName" type="text" formControlName="countryName" pInputText>
                                        </div>
                                        <div class="p-field p-col-12 p-md-5">
                                            <label for="countryCode">Country Code<span class="required-field">*</span></label>
                                            <input id="countryCode" type="text" formControlName="countryCode" pInputText>
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label for="isActive">Is Active</label>
                                            <br />
                                            <p-inputSwitch id="isActive" formControlName="isActive"></p-inputSwitch>
                                        </div>
                                    </div>
                                </form>
                                </div>
                                <div class="col-md-3 d-flex align-items-center">
                                    <button pButton pRipple type="button" label="{{buttonLabel}}" icon="pi pi-check"
                                class="p-button-sm p-button-raised p-button-success m-2" [disabled]="!this.countryForm.valid" (click)="save(countryForm)"></button>
                            <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
                                class="p-button-sm p-button-raised p-button-danger m-2" (click)="cancel()"></button>

                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="card">
                        <!-- <div class="devcare-table-card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <button pButton type="button" class="p-button-raised p-button-sm m-2" label="Add"
                                    icon="pi pi-plus" (click)="addCountryDetails()"
                                     *ngIf="(isCountryAdd === false) && (isCountryEdit === false) && sharedService.checkPermission('Admin_Add')"></button>
                                </div>
                                <div class="col-md-6">
                                </div>
                            </div>
                        </div> -->
                        <div class="devcare-table-card-header" *ngIf="showToggle">
                            <div class="row">
                                <div class="col-md-6">
            
                                </div>
                                <div class="col-md-6">
                                <p-multiSelect *ngIf="showToggle" [options]="allColumns" [(ngModel)]="selectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected" optionLabel="header" [showHeader] = "false" [showClear]="false" (onChange)="showAndHideColumn($event)" style="float: right;">
                                    <ng-template let-column pTemplate="item">
                                        <div class="column-item">
                                            <div>{{column.header}}</div>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                                </div>
                            </div>
                        </div>
                        <div class="card-body devcare-table-card-body" style="overflow: hidden;">
                            <p-table #dt2 [value]="countryList" [lazy]="true" paginatorDropdownAppendTo="body"
                                (onLazyLoad)="loadCountryList($event)" dataKey="id" [rows]="10"
                                [showCurrentPageReport]="true" [resizableColumns]="true" columnResizeMode="expand" 
                                [rowsPerPageOptions]="[10,25,50]" [loading]="loading" styleClass="p-datatable-gridlines"
                                [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [globalFilterFields]="['countryName','countryCode','isActive','createdBy','createdOn']">
                                <!-- <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                    </colgroup>
                                </ng-template> -->
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pResizableColumn style="width: 5rem" *ngIf="isShowColumns('action')">Action</th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('countryName')">Country Name  <span pSortableColumn="countryName" *ngIf="showSorting"><p-sortIcon field="countryName"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="countryName" #filterCountryName display="menu" [showAddButton]="false"
                                                [showMatchModes]="true" [matchModeOptions]="matchModeOptions" [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #countryName type="text" value="{{filters?.countryName[0]?.value}}" pInputText class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(countryName.value);applyFilterNew(dt2);filterCountryName.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('countryCode')">Country Code  <span pSortableColumn="countryCode" *ngIf="showSorting"><p-sortIcon field="countryCode"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="countryCode" display="menu" #filterCountryCode [showAddButton]="false"
                                                [showMatchModes]="true" [matchModeOptions]="matchModeOptions" [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #countryCode type="text" value="{{filters?.countryCode[0]?.value}}" pInputText class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(countryCode.value);applyFilterNew(dt2);filterCountryCode.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('isActive')">Is Active  <span pSortableColumn="isActive" *ngIf="showSorting"><p-sortIcon field="isActive"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="isActive" display="menu" #filterIsActive [showAddButton]="false"
                                                [showMatchModes]="false"  [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <!--<input #isActive type="text" value="{{filters?.isActive[0]?.value}}" pInputText class="pinputHeight">-->
                                                    <p-dropdown #isActive [options]="statusValues" [(ngModel)] ="selectedStatusId" (onChange)="getStatusOnChange($event)"></p-dropdown>
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="clearStatus();filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(isActive.value);applyFilterNew(dt2);filterIsActive.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>

                                            
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('createdBy')">Created By  <span pSortableColumn="createdBy" *ngIf="showSorting"><p-sortIcon field="createdBy"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="createdBy" display="menu" #filterCreatedBy [showAddButton]="false"
                                                [showMatchModes]="true" [matchModeOptions]="matchModeOptions" [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #createdBy type="text" value="{{filters?.createdBy[0]?.value}}" pInputText class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(createdBy.value);applyFilterNew(dt2);filterCreatedBy.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('createdOn')">Created On <span pSortableColumn="createdOn" *ngIf="showSorting"><p-sortIcon field="createdOn"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" type="date" field="createdOn" display="menu" #filterCreatedOn [showAddButton]="showAddRuleButton" [showOperator]="false"  
                                            [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false" [showApplyButton]="false">
                                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                <p-calendar #createdOn inputId="navigators" inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [appendTo]="p-calendar" [ngModel]="value"></p-calendar>
                                               
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(createdOn.value);applyFilterNew(dt2);filterCreatedOn.hide()">Apply</p-button>
                                                    </div>
                                            </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        
                                    </tr>
                                    <tr [hidden]="!showFilters">
                                        <th *ngIf="isShowColumns('action')"></th>
                                        <th *ngIf="isShowColumns('countryName')">{{filters?.countryName[0]?.value}}</th>
                                        <th *ngIf="isShowColumns('countryCode')">{{filters?.countryCode[0]?.value}}</th>
                                        <!--<th *ngIf="isShowColumns('isActive')">{{filters?.isActive[0]?.value}}</th>-->
                                        <th *ngIf="isShowColumns('isActive')">{{selectedStatus}}</th>
                                        <th *ngIf="isShowColumns('createdBy')">{{filters?.createdBy[0]?.value}}</th>
                                        <th *ngIf="isShowColumns('createdOn')">{{filters?.createdOn[0]?.value| date:'MM/dd/yyyy'}} <span *ngIf="filters?.createdOn.length > 1">-</span> {{filters?.createdOn[1]?.value | date:'MM/dd/yyyy'}}</th>
                                    </tr>
                                </ng-template>
                               
                                <ng-template pTemplate="body" let-countryList>
                                    <tr>
                                        <td *ngIf="isShowColumns('action')"> <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v"
                                                    (click)="selectedGridMenuItem = countryList; menu.toggle($event)"></i></a>
                                            <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
                                        </td>
                                        <td *ngIf="isShowColumns('countryName')"><span class="table-col-view"><a [routerLink]="" (click)="showCountryDetails(countryList.countryId)">{{countryList.countryName}}</a></span></td>
                                        <td *ngIf="isShowColumns('countryCode')"><span>{{countryList.countryCode}}</span></td>
                                        <td style="width: 8rem" *ngIf="isShowColumns('isActive')"><span class="customer-badge status-active" *ngIf="countryList.isActive">Active</span>
                                            <span class="customer-badge status-inactive" *ngIf="!countryList.isActive">Inactive</span>
                                        </td>
                                        <td *ngIf="isShowColumns('createdBy')"><span>{{countryList?.createdByUser?.firstName}}</span></td>
                                        <td *ngIf="isShowColumns('createdOn')"><span>{{countryList.createdOn | date:'MM/dd/yyyy'}}</span></td>
                                      
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td [attr.colspan]="selectedColumns.length">No Countries found.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
            </div>
        </div>
    </div>
    <p-toast position="bottom-center"></p-toast>
</section>